import classNames from 'classnames';

import CMSObjectForm from './CMSObjectForm';
import DateSelect from '../../../../../components/UI/Input/DateSelect/DateSelect';

const DisplayObject = props => {
	const handleChange = e => {
		props.setUpdateObject({
			...props.updateObject,
			[e.target.name]: e.target.value,
		});

		props.setWasEdited(true);
	};

	const currentYear = new Date().getFullYear();

	return (
		<>
			{props.updateObject.ID && props.updateObject.ObjectType ? (
				<>
					<h3
						className={classNames(
							props.Styles.Section,
							props.Styles.InformationContainer
						)}
					>
						{props.cmsObjectID}: {props.updateObject.Description}
					</h3>
					<div className={props.Styles.DetailsContainer}>
						<div className={props.Styles.flexRow}>
							<div className={props.Styles.Detail}>
								<p>
									<span className={props.Styles.DetailLabel}>
										Status:
									</span>
									<span className={props.Styles.DetailValue}>
										{props.updateObject.Status}
									</span>
								</p>
								<p>
									<span className={props.Styles.DetailLabel}>
										Type:
									</span>
									<span className={props.Styles.DetailValue}>
										{props.updateObject.ObjectType.Name}
									</span>
								</p>

								<p>
									<span className={props.Styles.DetailLabel}>
										Created By:
									</span>
									<span className={props.Styles.DetailValue}>
										{props.updateObject.CreateUser}
									</span>
								</p>
								<p>
									<span className={props.Styles.DetailLabel}>
										Created On:
									</span>
									<span className={props.Styles.DetailValue}>
										{new Date(
											Date.parse(
												props.updateObject.CreateDate
											)
										).toLocaleDateString()}
									</span>
								</p>

								<p>
									<span className={props.Styles.DetailLabel}>
										Updated On:
									</span>
									<span className={props.Styles.DetailValue}>
										{new Date(
											Date.parse(
												props.updateObject.MaintDate
											)
										).toLocaleDateString()}
									</span>
								</p>

								<p>
									<span className={props.Styles.DetailLabel}>
										Updated By:
									</span>
									<span className={props.Styles.DetailValue}>
										{props.updateObject.MaintUser}
									</span>
								</p>
							</div>
						</div>
					</div>
					<div
						className={classNames(
							props.Styles.Section,
							props.Styles.FormContainer
						)}
					>
						<div>
							<div>
								<span className={props.Styles.DetailLabel}>
									Start Date
								</span>
								<DateSelect
									name='StartDate'
									onChange={handleChange}
									value={props.updateObject.StartDate}
									extras={{
										yearStart: currentYear,
										yearEnd: currentYear + 10,
									}}
								/>
							</div>

							<div>
								<span className={props.Styles.DetailLabel}>
									End Date
								</span>
								<DateSelect
									name='EndDate'
									onChange={handleChange}
									value={props.updateObject.EndDate}
									extras={{
										yearStart: currentYear,
										yearEnd: currentYear + 10,
									}}
								/>
							</div>
						</div>
						<CMSObjectForm {...props} />
					</div>
				</>
			) : null}
		</>
	);
};

export default DisplayObject;
